import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import ContactUsForm from "components/forms/TwoColContactUsWithIllustrationFullForm.js";
// import ContactDetails from "components/cards/ThreeColContactDetails.js";

// const Address = tw.span`leading-relaxed`;
// const AddressLine = tw.span`block`;
// const Email = tw.span`text-sm mt-6 block text-gray-500`;
// const Phone = tw.span`text-sm mt-0 block text-gray-500`;

export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <ContactUsForm description="Feel free to get in touch with us at any time. We're here to assist you with all your nutrition and wellness needs. Let's make your wellness journey a success together!" />
      {/* <ContactDetails
        cards={[
          {
            title: "Delhi",
            description: (
              <>
                <Address>
                  <AddressLine>Nalendra Nagar</AddressLine>
                  <AddressLine>Hyderabad, Telangana</AddressLine>
                </Address>
                <Email>helpyourself@gmail.com</Email>
                <Phone>+91 903 991-6988</Phone>
              </>
            ),
          },
          {
            title: "Mumbai",
            description: (
              <>
                <Address>
                  <AddressLine>Nalendra Nagar</AddressLine>
                  <AddressLine>Hyderabad, Telangana</AddressLine>
                </Address>
                <Email>helpyourself@gmail.com</Email>
                <Phone>+91 903 991-6988</Phone>
              </>
            ),
          },
          {
            title: "Pune",
            description: (
              <>
                <Address>
                  <AddressLine>Nalendra Nagar</AddressLine>
                  <AddressLine>Hyderabad, Telangana</AddressLine>
                </Address>
                <Email>helpyourself@gmail.com</Email>
                <Phone>+91 903 991-6988</Phone>
              </>
            ),
          },
          {
            title: "hyderabad",
            description: (
              <>
                <Address>
                  <AddressLine>Nalendra Nagar</AddressLine>
                  <AddressLine>Hyderabad, Telangana</AddressLine>
                </Address>
                <Email>helpyourself@gmail.com</Email>
                <Phone>+91 903 991-6988</Phone>
              </>
            ),
          },
          {
            title: "chennai",
            description: (
              <>
                <Address>
                  <AddressLine>Nalendra Nagar</AddressLine>
                  <AddressLine>Hyderabad, Telangana</AddressLine>
                </Address>
                <Email>helpyourself@gmail.com</Email>
                <Phone>+91 903 991-6988</Phone>
              </>
            ),
          },
          {
            title: "Noida",
            description: (
              <>
                <Address>
                  <AddressLine>Nalendra Nagar</AddressLine>
                  <AddressLine>Hyderabad, Telangana</AddressLine>
                </Address>
                <Email>helpyourself@gmail.com</Email>
                <Phone>+91 903 991-6988</Phone>
              </>
            ),
          },
        ]}
      /> */}
      <Footer />
    </AnimationRevealPage>
  );
};
